import { ColumnDef } from '@tanstack/react-table';

// eslint-disable-next-line import/prefer-default-export
export function getCompleteOrderState(columns: ColumnDef<any, any>[]) {
	return columns
		.map((col) => col.id)
		.filter((id): id is string => id !== undefined);
}
